import mmMessages from '../assets/messages/mm_MM.json';
import enMessages from '../assets/messages/en_US.json';

export default {
    install: (app, options) => {
        app.config.globalProperties.$createLanguageSelectionFlag = $createLanguageSelectionFlag;
        app.config.globalProperties.$deleteLanguageSelectionFlag = $deleteLanguageSelectionFlag;
        app.config.globalProperties.$changeLocale = $changeLocale;
        app.config.globalProperties.$retrieveLocale = $retrieveLocale;
        app.config.globalProperties.$retrieveMessageBundle = $retrieveMessageBundle;
        app.config.globalProperties.$getLocalizedMessage = $getLocalizedMessage;      
        app.provide('messageBundle', options);
    }
}

export function $createLanguageSelectionFlag(ins) {   
    ins.$store.dispatch('createLanguageSelectionFlag', true);
}

export function $deleteLanguageSelectionFlag(ins) {
    ins.$store.dispatch('removeLanguageSelectionFlag');
}

export function $changeLocale(ins,locale){
    if (typeof Storage !== "undefined") {
        sessionStorage.setItem("locale",locale);       
    }
    
    ins.$retrieveMessageBundle(ins);
}

export function $retrieveLocale(ins){
    
    var locale=ins.$store.state.i18n.locale;
    if(locale){
      console.log("Found locale!");          
    }else{
        if (typeof Storage !== "undefined") {
            locale=sessionStorage.getItem("locale");
        }
    } 
    
      
    return locale;
 }

 export function $retrieveMessageBundle(ins){
    
    var definedLocale=null;
    if (typeof Storage !== "undefined") {
        definedLocale=sessionStorage.getItem("locale");
    }
    if(!definedLocale){
        definedLocale="mm_MM";
    }

    
    
    var locale=ins.$store.state.i18n.locale;
    //console.log("locale2:",locale2);
    //console.log("locale:",locale);
    var messageBundle=ins.$store.state.i18n.messageBundle;
    
    if(!messageBundle||(locale!==definedLocale)){
        locale=definedLocale;
        ins.$store.dispatch('createLocale',locale); 
        if('mm_MM'===locale){
            messageBundle=mmMessages;            
        }else{
            messageBundle=enMessages;            
        }
        ins.$store.dispatch('createMessageBundle',messageBundle); 
    }
    return messageBundle;
 }

 export function $getLocalizedMessage(ins,bundleSource,keyMsg,displayValueWhenKeyNotFound){
    
    if(ins&&keyMsg&&bundleSource){
        if(bundleSource){
            console.log(bundleSource);
            let msg=bundleSource[keyMsg];
            if(msg){
                return msg;
            }
        }
    }

    return displayValueWhenKeyNotFound?displayValueWhenKeyNotFound:keyMsg;

 }